import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/default/login/login.component';
import { DashboardComponent } from './components/features/dashboard/dashboard.component';
import { PatientsComponent } from './components/features/patients/patients.component';
import { AppointmentsComponent } from './components/features/appointments/appointments.component';
import { ConsultationComponent } from './components/features/consultation/consultation.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ShowcasePage1Component } from './components/showcase/showcase-page1.component';
import { ShowcasePage2Component } from './components/showcase/showcase-page2.component';
import { authGuard, loginGuard, adminLoginGuard } from './guards/auth.guard';
import { featureGuard } from './guards/feature.guard';

// Admin Components
import { AdminLoginComponent } from './components/admin/admin-login/admin-login.component';
import { AdminForgotPasswordComponent } from './components/admin/admin-forgot-password/admin-forgot-password.component';
import { AdminResetPasswordComponent } from './components/admin/admin-reset-password/admin-reset-password.component';

// Not Found Component
import { NotFoundComponent } from './components/default/not-found/not-found.component';
import { ThemeSettingComponent } from './components/settings/theme-setting.component/theme-setting.component';
import { BillingSettingComponent } from './components/settings/billing-setting.component/billing-setting.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  // Admin Routes
  {
    path: 'admin/login',
    component: AdminLoginComponent,
    canActivate: [adminLoginGuard]
  },
  {
    path: 'admin/forgot-password',
    component: AdminForgotPasswordComponent
  },
  {
    path: 'admin/reset-password',
    component: AdminResetPasswordComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('./components/admin/admin.routes').then(m => m.adminRoutes)
  },
  // Regular App Routes
  {
    path: '',
    loadChildren: () =>
      import('./components/layout/layout.routes').then(m => m.layoutRoutes),
    canActivate: [authGuard]
  },

  // {
  //   path: '',
  //   component: LayoutComponent,
  //   canActivate: [authGuard],
  //   children: [
  //     // { path: 'dashboard', component: DashboardComponent, canActivate: [featureGuard], data: { feature: 'dashboard' } },
  //     // { path: 'patients', component: PatientsComponent, canActivate: [featureGuard], data: { feature: 'patients' } },
  //     // { path: 'appointments', component: AppointmentsComponent, canActivate: [featureGuard], data: { feature: 'appointments' } },
  //     // { path: 'medical-records', component: MedicalRecordsComponent, canActivate: [featureGuard], data: { feature: 'medical-records' } },
  //     // { path: 'prescriptions', component: PrescriptionsComponent, canActivate: [featureGuard], data: { feature: 'prescriptions' } },
  //     // { path: 'billing', component: BillingComponent, canActivate: [featureGuard], data: { feature: 'billing' } },
  //     // { path: 'analytics', component: AnalyticsComponent, canActivate: [featureGuard], data: { feature: 'analytics' } },
  //     // { path: 'messages', component: MessagesComponent, canActivate: [featureGuard], data: { feature: 'messages' } },
  //     // { path: 'consultation', component: ConsultationComponent, canActivate: [featureGuard], data: { feature: 'consultation' } },
  //     // { path: 'patient-console/:patientId', component: PatientConsoleComponent, canActivate: [featureGuard], data: { feature: 'patient-console' } },
  //     // { path: 'users', component: UsersComponent, canActivate: [featureGuard], data: { feature: 'users' } },
  //     // { path: 'settings', component: SettingsComponent, canActivate: [featureGuard], data: { feature: 'settings' } },
  //     // { path: 'showcase/page1', component: ShowcasePage1Component },
  //     // { path: 'showcase/page2', component: ShowcasePage2Component }
  //     { path: 'dashboard', loadComponent: () => import('./components/features/dashboard/dashboard.component').then(m => m.DashboardComponent), },
  //     { path: 'patients', loadComponent: () => import('./components/features/patients/patients.component').then(m => m.PatientsComponent), },
  //     { path: 'appointments', loadComponent: () => import('./components/features/appointments/appointments.component').then(m => m.AppointmentsComponent), },
  //     { path: 'medical-records', loadComponent: () => import('./components/features/medical-records/medical-records.component').then(m => m.MedicalRecordsComponent), },
  //     { path: 'prescriptions', loadComponent: () => import('./components/features/prescriptions/prescriptions.component').then(m => m.PrescriptionsComponent), },
  //     { path: 'billing', loadComponent: () => import('./components/features/billing/billing.component').then(m => m.BillingComponent), },
  //     { path: 'analytics', loadComponent: () => import('./components/features/analytics/analytics.component').then(m => m.AnalyticsComponent), },
  //     { path: 'messages', loadComponent: () => import('./components/features/messages/messages.component').then(m => m.MessagesComponent), },
  //     { path: 'consultation', loadComponent: () => import('./components/features/consultation/consultation.component').then(m => m.ConsultationComponent), },
  //     { path: 'patient-console/:patientId', loadComponent: () => import('./components/features/patients/patient-console/patient-console.component').then(m => m.PatientConsoleComponent), },
  //     { path: 'users', loadComponent: () => import('./components/features/users/users.component').then(m => m.UsersComponent), },
  //     { path: 'settings', loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent), },
  //     { path: 'settings/theme', loadComponent: () => import('./components/settings/theme-setting.component/theme-setting.component').then(m => m.ThemeSettingComponent) },
  //     { path: 'settings/billing', loadComponent: () => import('./components/settings/billing-setting.component/billing-setting.component').then(m => m.BillingSettingComponent) },
  //     // { path: 'showcase/page1', loadComponent: () => import('./components/showcase/page1/page1.component').then(m => m.ShowcasePage1Component) },
  //     // { path: 'showcase/page2', loadComponent: () => import('./components/showcase/page2/page2.component').then(m => m.ShowcasePage2Component) },
  //     { path: 'template-builder', loadComponent: () => import('./components/features/template-builder/template-builder.component').then(m => m.TemplateBuilderComponent) },
  //     { path: 'template-renderer', loadComponent: () => import('./components/features/template-renderer/template-renderer.component').then(m => m.TemplateRendererComponent) },
  //     { path: 'prescription-preview', loadComponent: () => import('./components/features/prescription-preview/prescription-preview.component').then(m => m.PrescriptionPreviewComponent) },
  //   ]
  // },
  // Wildcard route - must be last
  {
    path: '**',
    component: NotFoundComponent
  }
];
